/**
 * Matches the backend ApiErrorResponseBuilder format:
 * { error: "Conflict", message: "...", status: 409 }
 */
export interface ApiErrorResponse {
  error: string;
  message: string;
  status: number;
}

/**
 * Parses an API error into a user-facing message.
 * Handles both the ApiErrorResponse format and legacy error shapes.
 */
export function parseApiError(err: unknown, fallback: string): string {
  if (!err || typeof err !== 'object') return fallback;

  const axiosError = err as {
    response?: { data?: Record<string, unknown> };
    message?: string;
  };

  const data = axiosError?.response?.data;
  if (data && typeof data === 'object') {
    if (typeof data.message === 'string' && data.message.trim()) return data.message;
    if (typeof data.error === 'string' && data.error.trim()) return data.error;
  }

  if (typeof axiosError?.message === 'string' && axiosError.message.trim()) {
    return axiosError.message;
  }

  return fallback;
}
